module.exports = __webpack_public_path__ + "img/user.d1d2228f.svg";